var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"has-text-centered"},[_vm._v(_vm._s(_vm.index))]),_c('td',{staticClass:"has-text-centered"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }